/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * The kinds of DATEV account numbers a company or person can carry.
 * Mirrors `DatevAccountTypeEnum` of the backend.
 */
export enum DatevAccountTypeEnum {
  /**
   * Customer number ("Kundennummer"), the buyer side of outbound invoices
   */
  DEBTOR = "debtor",

  /**
   * Supplier number ("Lieferantennummer"), the seller side of inbound invoices
   */
  CREDITOR = "creditor"
}
